import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash-es';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { CatalogClient } from 'src/WebApiController';

export const useGetCategoryResults = (
  categoryIds?: number[],
  disabled?: boolean
) => {
  const { activeAccountWebClientConfig } = useAppContext();

  const { trackError } = useClientLogContext();

  const queryKey = [
    'CatalogClient.getCategoryUrlsByIds',
    (categoryIds ?? []).toSorted(),
  ];

  const shouldQuery =
    !disabled &&
    Boolean(
      activeAccountWebClientConfig.activeAccountId && !isEmpty(categoryIds)
    );
  const categoriesQuery = useQuery({
    queryKey,
    queryFn: async () => {
      if (!shouldQuery) return null;

      const categories = await new CatalogClient(
        activeAccountWebClientConfig
      ).getCategoryUrlsByIds(categoryIds!);

      return categories;
    },

    enabled: shouldQuery,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    meta: {
      onError: (error: ErrorTypes) => {
        trackError('CatalogClient.getCategoryUrlsByIds', error, {
          categoryIds,
        });
      },
    },
  });

  return {
    categoryResults: categoriesQuery.data,
    isLoading: categoriesQuery.isLoading,
  };
};
